<div class="flex-grow">{{data.message}}</div>
<div>
    <button class="btn" mat-button (click)="dismiss()">{{"shared.dismiss" | translate}}</button>
</div>
